import { createFileRoute, Outlet } from '@tanstack/react-router'
import { FinanceRepositoriesProvider } from '_/features/finance/ui/contexts/finance-repositories-provider'
import { useHouseholdBootstrap } from '_/features/finance/ui/hooks/use-household-bootstrap'
import type { ReactNode } from 'react'

// BootstrapGate lives inside the provider so it can use the repositories; it
// ensures the caller has a household before any finance screen renders data.
const BootstrapGate = ({ children }: { children: ReactNode }) => {
	useHouseholdBootstrap()
	return <>{children}</>
}

const FinanceLayout = () => {
	return (
		<FinanceRepositoriesProvider>
			<BootstrapGate>
				<Outlet />
			</BootstrapGate>
		</FinanceRepositoriesProvider>
	)
}

export const Route = createFileRoute('/_authenticated/finance')({
	component: FinanceLayout,
})
